// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__Ty49L","rootSmall":"AddTileButton_rootSmall__1iOQV"};